var _a, _b;
export var PLACEMENT_TO_TEXT_POSITION_MAP = (_a = {},
    _a['START'] = 'left',
    _a['CENTER'] = 'center',
    _a['END'] = 'right',
    _a);
export var PLACEMENT_TO_FLEX_MAP = (_b = {},
    _b['START'] = 'flex-start',
    _b['CENTER'] = 'center',
    _b['END'] = 'flex-end',
    _b);
//# sourceMappingURL=consts.js.map